import { Box, styled } from '@mui/system';

export const Container = styled(Box)({
  margin: '20px 0',
  '.follow-up-status-chip': {
    display: 'inline-flex'
  }
});
